import { Controller } from "@hotwired/stimulus"
import { animate, inView } from "motion"

// Counts a number up from 0 when it scrolls into view, formatted for vi-VN
// (12480000 → "12.480.000"). The server renders the final value so no-JS
// visitors and crawlers see the real number; reduced-motion keeps it static.
export default class extends Controller {
  static values = { number: Number, suffix: { type: String, default: "" } }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    const format = new Intl.NumberFormat("vi-VN")
    this.stop = inView(this.element, () => {
      animate(0, this.numberValue, {
        duration: 1.4,
        ease: "easeOut",
        onUpdate: (latest) => {
          this.element.textContent = format.format(Math.round(latest)) + this.suffixValue
        }
      })
    }, { amount: 0.6 })
  }

  disconnect() {
    this.stop?.()
  }
}
